import React, { useState, useEffect } from 'react';
// src/components/Topbar.jsx
// IMPROVEMENT: Live price ticker strip below the main nav bar.
// Scrolls continuously left showing top coin prices + 24h change.
// CSS-only animation — zero JS overhead on each frame.
import { useApp } from '../context/AppContext';
import { messages as messagesApi } from '../services/api';
import Logo from './Logo';
import { G, GD, GL } from '../constants';

function Topbar() {
  const { user, prices, darkMode, setDarkMode, setSidebar, setPage, setSelCoin, unreadCount, bord, bg2, s, wsConnected, diamonds, coins, portfolio } = useApp();

  // v228: DM unread count for the ✉️ envelope icon badge.
  // Polls every 15s (cheap query), and refetches whenever the WS dm_new_message
  // event fires (so badge updates instantly on incoming DM).
  const [dmUnread, setDmUnread] = useState(0);
  useEffect(() => {
    if (!user?.id) return;
    let active = true;
    const fetchUnread = async () => {
      try {
        const r = await messagesApi.unreadCount();
        if (active && r?.success) setDmUnread(r.unread_count || 0);
      } catch(_) { /* silent — header badge is non-critical */ }
    };
    fetchUnread();
    const id = setInterval(fetchUnread, 15000);
    // Also refresh on WS dm_new_message
    let socket;
    try {
      const { getSocket } = require('../hooks/useSocket');
      socket = getSocket();
      if (socket) socket.on('dm_new_message', fetchUnread);
    } catch(_) {}
    return () => {
      active = false;
      clearInterval(id);
      if (socket) try { socket.off('dm_new_message', fetchUnread); } catch(_) {}
    };
  }, [user?.id]);

  const tickerCoins = prices.slice(0, 10);
  const balanceUsd = parseFloat(portfolio?.balance_usdt ?? 0);

  return (
    <div style={{ position:'sticky', top:0, zIndex:100, background:bg2 }}>

      {/* ── Main nav row ── */}
      <div style={{ borderBottom:`1px solid ${bord}`, height:56, display:'flex', alignItems:'center', gap:10, padding:'0 14px' }}>
        <div style={{ cursor:'pointer', fontSize:22, userSelect:'none' }} onClick={() => setSidebar(true)}>☰</div>
        <div onClick={() => setPage('home')}
          style={{ display:'flex', alignItems:'center', gap:6, cursor:'pointer', flex:1 }}>
          <Logo size={34}/>
          <div style={{ fontWeight:800, letterSpacing:2.5, fontSize:15,
            background:`linear-gradient(90deg,${GD},${G},${GL})`,
            WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            PAPER CRYPTO
          </div>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {/* v207: free tier shows N/3 trades (was N/1). Trade 1 free, trades
              2 and 3 require ads, then hard daily cap. Premium check uses
              is_premium flag, plan tier ID, OR large trades_left number.
              v275 (G4.23a — Doubt #80a/Rule F): Removed dead literals 'premium'
              and 'pro' — backend API returns subscription.plan_id (∈ '1d'/'1m'/
              '3m'/'12m'/'free'), never 'premium' or 'pro'. is_premium boolean
              flag is the canonical premium signal from /trading/portfolio.
              S-097 (2026-05-31): Free-user badge now uses 4-tier color cascade for visual narrative:
                3/3 → GOLD   (#F5C518) — default brand color
                2/3 → BLUE   (#3B82F6) — informational
                1/3 → AMBER  (#F59E0B) — warning
                0/3 → GREEN  (#0ECB81) — "Upgrade →" naturally matches ∞ premium green
              Mobile mirrors this exact scheme in HomeScreen.js (Rule Q parity). */}
          {/* ECONOMY: the badge is now PLAN, not a trade counter.
              Free spot trading is unlimited, so "3/3 trades" was both wrong and a wall in
              users' heads — they stopped after three. And "∞ Unlimited" said nothing about
              what a subscription actually buys. FREE vs PRO is honest, survives every future
              change to the caps, and needs no maintenance when limits move. */}
          {(user.is_premium ||
            ['1d','1m','3m','6m','12m'].includes(user.plan) ||
            (typeof user.trades_left === 'number' && user.trades_left > 100))
            ? <span style={{ ...s.tag, color:'#F5C518', borderColor:'#F5C518', fontWeight:900 }}>PRO</span>
            : <span
                onClick={() => setPage('store')}
                style={{ ...s.tag, color:'#8A8F98', borderColor:'#3A3F48', cursor:'pointer', fontWeight:800 }}>
                FREE
              </span>}
          {/* FIX: live WS connection indicator */}
          <span title={wsConnected ? 'Live' : 'Reconnecting...'} style={{
            width:7, height:7, borderRadius:'50%', flexShrink:0,
            background: wsConnected ? '#0ECB81' : '#F6465D',
            boxShadow: wsConnected ? '0 0 5px #0ECB81' : '0 0 5px #F6465D',
            display:'inline-block',
          }}/>
          <div onClick={() => setDarkMode(d => !d)} style={{ cursor:'pointer', fontSize:18 }}>
            {darkMode ? '☀️' : '🌙'}
          </div>
          {user && (
            <div style={{ display:'flex', alignItems:'center', gap:4 }}>
              {/* 💵 Portfolio Balance */}
              <div onClick={() => setPage('portfolio')}
                style={{ cursor:'pointer', display:'flex', alignItems:'center', gap:3,
                  background:'#0ECB8118', border:'1px solid #0ECB8144',
                  borderRadius:14, padding:'3px 8px', fontSize:11, fontWeight:800, color:'#0ECB81' }}>
                💵 ${balanceUsd >= 1000 ? (balanceUsd/1000).toFixed(1)+'K' : balanceUsd.toFixed(0)}
              </div>
              {/* 💎 Diamonds — tap to go to Store */}
              <div onClick={() => setPage('store')}
                style={{ cursor:'pointer', display:'flex', alignItems:'center', gap:3,
                  background:'#B26BFF18', border:'1px solid #B26BFF44',
                  borderRadius:14, padding:'3px 8px', fontSize:11, fontWeight:800, color:'#B26BFF' }}>
                💎 {diamonds || 0}
              </div>
              {/* 🪙 Coins (Coins) — tap to go to gamification */}
              <div onClick={() => setPage('gamification')}
                style={{ cursor:'pointer', display:'flex', alignItems:'center', gap:3,
                  background:'#F5C51818', border:'1px solid #F5C51844',
                  borderRadius:14, padding:'3px 8px', fontSize:11, fontWeight:800, color:'#F5C518' }}>
                🪙 {coins || 0}
              </div>
            </div>
          )}
          <div onClick={() => setPage('notifications')} style={{ cursor:'pointer', fontSize:18, position:'relative' }}>
            🔔
            {unreadCount > 0 && (
              <span style={{ position:'absolute', top:-4, right:-4, background:'#F6465D', color:'white',
                borderRadius:'50%', width:14, height:14, fontSize:9,
                display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700 }}>
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </div>

          {/* v228: DM messages icon — gold envelope, click → Inbox page */}
          <div onClick={() => setPage('inbox')}
            style={{ cursor:'pointer', position:'relative', display:'inline-flex', alignItems:'center' }}
            title="Messages"
            aria-label="Open inbox">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display:'block' }}>
              {/* Envelope body — gold gradient fill, dark border */}
              <defs>
                <linearGradient id="dmEnvGrad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%"  stopColor={GL || '#FFE066'}/>
                  <stop offset="55%" stopColor={G  || '#F5C518'}/>
                  <stop offset="100%" stopColor={GD || '#C9960C'}/>
                </linearGradient>
              </defs>
              {/* Body */}
              <path d="M3 6.5C3 5.67 3.67 5 4.5 5h15c.83 0 1.5.67 1.5 1.5V18c0 .83-.67 1.5-1.5 1.5h-15A1.5 1.5 0 0 1 3 18V6.5z"
                fill="url(#dmEnvGrad)" stroke="#1a1a1a" strokeWidth="1.2" strokeLinejoin="round"/>
              {/* Flap (top V) */}
              <path d="M3.4 6.7L12 12.7l8.6-6"
                fill="none" stroke="#1a1a1a" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
              {/* Subtle highlight */}
              <path d="M5.5 7.5l1.2 0.8" stroke="#FFFFFF99" strokeWidth="1" strokeLinecap="round"/>
            </svg>
            {dmUnread > 0 && (
              <span style={{ position:'absolute', top:-4, right:-4, background:'#F6465D', color:'white',
                borderRadius:'50%', width:14, height:14, fontSize:9,
                display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700 }}>
                {dmUnread > 9 ? '9+' : dmUnread}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* ── Live price ticker strip ── */}
      {tickerCoins.length > 0 && (
        <div style={{ height:28, background:darkMode?'#0A0700':'#FFF8D0',
          borderBottom:`1px solid ${bord}`, overflow:'hidden',
          display:'flex', alignItems:'center' }}>
          <style>{`
            @keyframes tickerScroll {
              0%   { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}</style>
          {/* Double coins so loop is seamless */}
          <div style={{ display:'flex', whiteSpace:'nowrap',
            animation:'tickerScroll 30s linear infinite', willChange:'transform' }}>
            {[...tickerCoins, ...tickerCoins].map((coin, i) => {
              const isUp = coin.change_24h >= 0;
              return (
                <span key={`${coin.id}-${i}`}
                  onClick={() => { setSelCoin(coin); setPage('trade'); }}
                  style={{ display:'inline-flex', alignItems:'center', gap:5,
                    padding:'0 16px', fontSize:11, fontWeight:700,
                    borderRight:`1px solid ${bord}`, cursor:'pointer', height:28 }}>
                  <span style={{ color:darkMode?'#bbb':'#666' }}>{coin.symbol}</span>
                  <span style={{ color:G }}>
                    ${coin.price >= 1000
                      ? coin.price.toLocaleString(undefined,{maximumFractionDigits:0})
                      : coin.price?.toFixed(2)}
                  </span>
                  <span style={{ color:isUp?'#0ECB81':'#F6465D' }}>
                    {isUp?'▲':'▼'}{Math.abs(coin.change_24h)?.toFixed(1)}%
                  </span>
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default React.memo(Topbar);
